import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@Env/environment';
import { Image } from './image.model';
import { DaoGeneric } from '@Services/base/daoService';
import * as FileSaver from 'file-saver';
import {Document} from '../document/document.model';


@Injectable({
  providedIn: 'root'
})
export class ImageService extends DaoGeneric<Image> {
  private url = `${environment.baseUrl}/api_bdc/images/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  upload(image: Image): Observable<Image> {
    const formData: FormData = new FormData();

    if (typeof(image.file) !== 'string' && image.file) {
      formData.append('file', image.file, image.file.name);
    }
    formData.append('title', image.title);
    formData.append('description', image.description);

    return this.httpClient.post<Image>(this.url, formData);
  }

  getFile(id: number) {
    const url = `${environment.baseUrl}/api_bdc/download/`;
    const typeImg: Map<string, string> = new Map<string, string>();
    typeImg.set('type', 'img');
    typeImg.set('id', id.toString());
    const params = this._getUrlHttpParams(typeImg);

    return this.httpClient.get<Blob>(url, {
      params: params,
      responseType: 'blob' as 'json'
    });
  }

  download(id: number, file: string) {
    this.getFile(id).subscribe(data => {
      FileSaver.saveAs(data, file);
    });
  }
}
